<template>
	<div id="app">
		<div class="header">
			<!--<select class="select1 name" v-model="keshi" style="width: 90px;height: 35px;padding-left:10px;">-->
				<!--<option value="">课时</option>-->
				<!--<option v-for="item in keshi_data" :value="item.id">-->
					<!--{{item.name}}-->
				<!--</option>-->
			<!--</select>-->
			<!---->
			<input type="text" class="name" style="width: 90px;" v-model="pact_num" placeholder="合同编号" @keyup.enter="search" />
			<input type="text" class="name" style="width: 90px;" v-model="vip_name" placeholder="会员姓名" @keyup.enter="search" />
			<input type="text" class="name" style="width: 90px;" v-model="cabeza_name" placeholder="家长姓名" @keyup.enter="search" />
			<input type="text" class="name" style="width: 140px;" maxlength="11" v-model="cabeza_tel" placeholder="家长电话"
			 @keyup.enter="search" />
			<select class="select1 name" v-model="selectVal" @change="search" style="width: 90px;height: 35px;padding-left:10px;">
				<option value="">状态</option>
				<option
					v-for="item in option1"
					:value="item.content"
					:key="item.content"
				>{{item.content}}</option>
			</select>
			<select name="" @change="market_save" class="select2 name" v-model="select_Val" v-if="show_zj == 1" style="width: 90px;height: 38px;">
				<option value="">顾问</option>
				<option v-for="(item,index) in options" :value="item.user_id">
					{{ item.username }}
				</option>
			</select>
			<!--<el-select v-model="item_id" placeholder="请选择合约" style="width: 130px;margin-left: 10px;vertical-align: middle">-->
				<!--<el-option value="">请选择</el-option>-->
				<!--<el-option v-for="item in xiangmu" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
			<!--</el-select>-->
			<el-button type="warning" @click="search" icon="el-icon-search"></el-button>
			<button class="refresh-btn" @click="clear_search">
				<i class="el-icon-refresh"></i>
			</button>
			<el-button class="delete" :plain="true" @click="del" v-if="show_zj == 1">删除所属顾问</el-button>
			<!--<el-checkbox v-model="checked" style="margin-left: 12px;">待续约用户</el-checkbox>-->

			<el-dialog title="删除所属顾问" :visible.sync="centerDialogVisible" width="30%" center>
				<span>确认将顾问：{{select_name}}下的所有用户（{{market_num}}人）重新分配？且不可恢复</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="warning" @click="centerDialogVisible = false">确 定</el-button>
				</span>
			</el-dialog>
		</div>

		<el-table :data="tableData" border @sort-change="sort_change" style="width: 100%" :cell-style="getClass"
		 @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="40"></el-table-column>
            <!-- <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                    <span >{{ scope.row.gj_type ? scope.row.gj_type : '--' }}</span>
                </template>
            </el-table-column> -->
			<el-table-column label="会员姓名" width="90">
				<template slot-scope="scope">
					<span style="cursor: pointer;" @click="pop(scope.row.user_id)">{{ scope.row.baobao_name ? scope.row.baobao_name : '--' }}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column label="会员生日" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.baobao_birthday ? scope.row.baobao_birthday : '--' }}</span>
				</template>
			</el-table-column> -->
			<el-table-column label="家长" width="90">
				<template slot-scope="scope">
					<span>{{ scope.row.p_name ? scope.row.p_name : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="电话" width="110">
				<template slot-scope="scope">
					<span>{{ scope.row.p_phone ? scope.row.p_phone : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="合约名称" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.item_name ? scope.row.item_name : '--' }}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column label="合同编号" width="120">
				<template slot-scope="scope">
					<span>{{ scope.row.kahao ? scope.row.kahao : '--' }}</span>
				</template>
			</el-table-column> -->
			<!--<el-table-column label="剩余课时" width="80">-->
				<!--<template slot-scope="scope">-->
					<!--<span>{{ scope.row.y_keshi ? scope.row.y_keshi : '&#45;&#45;' }}</span>-->
				<!--</template>-->
			<!--</el-table-column>-->
			<el-table-column label="合同到期" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.e_time ? scope.row.e_time : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column width="100" label="上次跟进">
				<template slot-scope="scope">
					<span>{{ scope.row.last ? scope.row.last : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="跟进内容">
				<template slot-scope="scope">
					<span  style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ scope.row.neirong ? scope.row.neirong : '--' }}</span>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<div style="margin-top: 15px;">
			<el-button size="mini" type="warning" @click="move" style="float: left;margin-right: 15px;">转给他人</el-button>
			<el-pagination @current-change="handleCurrentChange" :current-page="now_page"
			 background  :page-size="10" prev-text="上一页"
			 next-text="下一页" :total="totalNum">
			</el-pagination>
		</div>

		<!--选择销售弹出框-->
		<el-dialog title="提示" :visible.sync="DialogVisible" center top="25vh" width="26%">
			<span style="color: red;vertical-align: middle;">*</span>
			<label>选择销售：</label>
			<select name="" v-model="sell_name" style="width: 250px;height: 30px;">
				<option value="">请选择销售</option>
				<option v-for="(item,index) in sellData" :value="item.user_id">
					{{ item.username }}
				</option>
			</select>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="DialogVisible = false">取 消</el-button>
				<el-button size="mini" type="warning" @click="confirm_move">确 定</el-button>
			</span>
		</el-dialog>

		<!--退回公海-->
		<el-dialog title="提示" :visible.sync="send_state" width="30%">
			<span>确定删除此学员？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="send_state = false">取 消</el-button>
				<el-button type="warning" @click="confirm_back">确 定</el-button>
			</span>
		</el-dialog>

		<!--潜客详细信息-->
		<transition name="fade">
			<div class="right-pop" v-show="popShow">
				<div> </div>
				<div class="head">
					<img src="/static/qmsj/img/genjin/boshi.png" class="head-img" />
					<span class="name">{{popData.baobao_name ? popData.baobao_name : '--'}}</span>
					<div class="right">
<!--						<span class="move" @click="jumpqian">早教续约</span>-->
<!--						<span class="move" @click="jumpqiantuoyu">托育续约</span>-->
						<span class="move" @click="send_back">删除</span>
						<img src="/static/qmsj/img/genjin/Close.png" @click="close" class="close" />
					</div>

					<div class="head_content">
						<span>最后跟进时间：{{popData.lasttime ? popData.lasttime : '--'}}</span>
						<span>下次跟进时间：{{popData.lastgjtime ? popData.lastgjtime : '--'}}</span>
						<span>跟进状态：{{popData.gj_type ? popData.gj_type : '--'}}</span>
						<br>
						<span>负责销售：{{popData.gwname ? popData.gwname : '--'}}</span>
						<span>采单人：{{popData.cdname ? popData.cdname : '--'}}</span>
						<span>用户分类：<input type="text" v-model="t_name" style="width: 80px;border-style: none; border-bottom-style: solid; outline: none;"
							 @focus="showtype=true" @blur="blurs">
							<button v-if="showtype&&showtype2" class="fencss" @click="get_type2(1)">保存</button>
							<button v-if="showtype&&!showtype2" class="fencss" @click="get_type2(2)">修改</button>
						</span>
					</div>
				</div>

				<!--tab切换-->
				<el-tabs type="border-card">
					<el-tab-pane label="详细信息">
						<!-- 展示信息的组件 -->
                        <genjinInfoBox :popData="popData"></genjinInfoBox>
					</el-tab-pane>

					<el-tab-pane label="跟进记录">
						<textarea v-model="text_val" placeholder="新建跟进记录...(必填，限200字)" name="" rows="" cols=""></textarea>
						<form class="down_form">
							<select name="" v-model="way_val" style="width: 12%;height: 27px;float: left;">
								<option value="">跟进方式</option>
								<option v-for="item in way" :value="item.name">
									{{item.name}}
								</option>
							</select>

							<el-date-picker value-format="yyyy-MM-dd" v-model="last_time" size="mini" type="date" placeholder="下次跟进时间">
							</el-date-picker>

							<select name="" v-model="follow_val" @change="update_gj_type" style="height: 27px;margin-left: 5px;">
								<option value="">跟进状态</option>
								<option
									v-for="item in option1"
									:value="item.content"
									:key="item.content"
								>{{item.content}}</option>
							</select>
							<input type="button" class="issue" name="" id="" @click="issue" value="发布" />

							<!--跟进记录-->
							<div class="record-content" v-for="(item,index) in recordData" v-show="recordShow">
								<div class="record">
									<span>跟进时间: {{item.create_time ? item.create_time : '--'}}</span>
									<span>预约时间: {{item.st_time ? item.st_time : '--'}}</span>
									<span>
										跟进方式: {{item.fangshi ? item.fangshi : '--'}}
										<button type="button" :class="visit_state ? 'yet' : 'not'" v-text="visit_txt" @click="visit(item.gj_id)"
										 v-show="index == 0">未到访</button>
									</span>
								</div>
								<img src="/static/qmsj/img/genjin/header.png" class="header-img" />
								<span class="img-txt">{{item.username ? item.username : '--'}}</span>
								<span class="right-txt" @click="del_record(item.gj_id)">删除</span>
								<div class="content">{{item.neirong ? item.neirong : '--'}}</div>
							</div>
						</form>
					</el-tab-pane>
				</el-tabs>
			</div>
		</transition>

		<!--删除跟进记录-->
		<el-dialog title="" :visible.sync="del_dialogVisible" width="30%">
			<span>是否删除此条记录？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="del_dialogVisible = false">取 消</el-button>
				<el-button type="warning" @click="confirm_del">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
    import genjinInfoBox from "../../components/genjinInfoBox";
	export default {
		components: { genjinInfoBox },
		data() {
			return {
				value1: '',
				value2: '',
				show_zj: 2,
				//分页
				totalNum: 0,
				now_page: 1,
				//单选
				radio: '1',
				isShow: false,
				//表格
				pact_num: '',
				vip_name: '',
				cabeza_name: '',
				cabeza_tel: '',
				selectVal: '',
				select_Val: '',
				select_name: '',
				token: '',
				userid: '',
				popData: [],
				recordData: [], //跟进记录
				record_id: '',
				recordShow: false,
				sell_name: '',
				sellData: [],
				popShow: false,
				dialogVisible: false,
				DialogVisible: false,
				centerDialogVisible: false,
				option1: [],
				way: [{
						name: '电话'
					},
					{
						name: '短信'
					},
					{
						name: '到店'
					}
				],
				way_val: '',
				follow_val: '',
				follow_type: [{
						name: '重点关注'
					},
					{
						name: '已跟进'
					},
					{
						name: '持续跟进'
					},
					{
						name: '预约未到访'
					},
					{
						name: '已到访'
					},
					{
						name: '放弃'
					}
				],
				market_num: 0, //顾问
				text_val: '', //文本域
				visit_state: false,
				del_dialogVisible: false, //确认删除弹出框
				visit_id: '', //记录ID
				del_id: '', //删除记录ID
				visit_txt: '已到访', //切换按钮
				courseData: [], //班级名称数据
				last_time: '', //下次跟进时间
				options: [],
				tableData: [],
				tables: [],
				send_state: false, //退回公海
				d_id: '',
				checked: false, //功能选择
				pageSize: 10, //每页显示条数
				multipleSelection: [], //多选数据
				showtype: false, //是否显示用户分类
				showtype2: false, //是否显示用户分类
				t_name: '', //用户分类
				xiangmu:'', // 合约项目
				item_id:'',  // 项目id
				keshi:'',
				keshi_data:[
					{name:'<5课时',id:5},
					{name:'<10课时',id:10},
					{name:'<15课时',id:15},
					{name:'<20课时',id:20},
					{name:'<25课时',id:25},
					{name:'<30课时',id:30},
				],
				isSubmit: false
			}
		},
		created() {
			let that = this
			that.token = that.$cookies.get('token');

			that.getData();
			that.getxm();
			//下拉框数据
			$.ajax({
				url: process.env.apiUrl +'saas/nn/sales',
				type: 'post',
				data: {
					token: that.token
				},
				success: function(data, status) {
					that.options = data.data
				},
				fail: function(err, status) {
					console.log(err)
				}
			})
			$.ajax({
				url: process.env.apiUrl +"saas/index/get_all_status",
				type: "post",
				data: {
					token: that.$cookies.get("token")
				},
				success: function(data, status) {
					that.option1 = data.data;
					that.$emit('getStatus', data.data)
				},
				fail: function(err, status) {
					console.log(err);
				}
			});
		},
		methods: {
            //续约
            jumpqian: function() {
                let self = this;
                self.$router.push({
                    name: 'huiyuanqianxin',
                    query: {
                        id: self.record_id,
                        type: 3 //跳转类型 区分从哪里跳转
                    }
                })
            },
      //续约
      jumpqiantuoyu: function() {
        let self = this;
        self.$router.push({
          name: 'tuoyuqianyue',
          query: {
            id: self.record_id,
            type: 3 //跳转类型 区分从哪里跳转
          }
        })
      },
            update_gj_type(){
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/update_gj_type',
                    type: 'post',
                    data: {
                        token: that.token,
                        user_id:that.record_id,
                        gj_type:that.follow_val
                    },
                    success: function(e) {

                    },
                })
            },
			getxm(){
				let that = this;
				$.ajax({
					url: process.env.apiUrl +'saas/biao/item_type',
					type: 'post',
					data: {
						token: that.token
					},
					success: function(data) {
						that.xiangmu = data.data
					},
				})
			},
			//表格数据
			getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/hygj',
					type: 'post',
					data: {
						hetong: this.pact_num,
						name: this.vip_name,
						pname: this.cabeza_name,
						pphone: this.cabeza_tel,
						type: this.selectVal,
						salesperson: this.select_Val,
						page: this.now_page,
						token: this.token
					},
					success: function(data, status) {
						loading.close()
						if (data.status == 1) {

							that.tableData = data.data
							//总条数
							that.totalNum = Number(data.map.count)
							that.show_zj = data.show_zj;
						} else {
							that.$message.error({
								message: data.msg
							})
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//排序
			sort_change(column, prop, order) {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/hygj',
					type: 'post',
					data: {
						orderby: column.order,
						hetong: this.pact_num,
						name: this.vip_name,
						pname: this.cabeza_name,
						pphone: this.cabeza_tel,
						type: this.selectVal,
						salesperson: this.select_Val,
						page: this.now_page,
						token: this.token
					},
					success: function(data, status) {
						that.tableData = data.data
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//切换顾问
			market_save() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/hygj',
					type: 'post',
					data: {
						hetong: this.pact_num,
						name: this.vip_name,
						pname: this.cabeza_name,
						pphone: this.cabeza_tel,
						type: this.selectVal,
						salesperson: this.select_Val,
						page: this.now_page,
						token: this.token
					},
					success: function(data, status) {
						that.tableData = data.data
						if (data.data.length !== 0) {
							that.market_num = that.tableData[0].num
							that.totalNum = data.data.count
						} else if (data.status == 2) {
							that.totalNum = 0
							that.market_num = 0
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//搜索
			search() {
				this.now_page = 1;
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/hygj',
					type: 'post',
					data: {
						keshi: that.keshi,
						hetong: that.pact_num,
						name: that.vip_name,
						pname: that.cabeza_name,
						pphone: that.cabeza_tel,
						type: that.selectVal,
						salesperson: that.select_Val,
						page: that.now_page,
						token: that.token,
						item_id: that.item_id
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.tableData = data.data
							that.totalNum = Number(data.map.count)
						} else {
							that.tableData = []
							that.totalNum = 0
							that.$message.error({
								message: data.msg
							})
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			getClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'color:rgb(98, 158, 241)'
				}
			},
			//			右侧弹出框
			pop(id) {
				document.documentElement.scrollTop = document.body.scrollTop = 0;
                let that = this
                that.record_id = id
                that.popShow = true
                that.get_record()
				$.ajax({
					url: process.env.apiUrl +'saas/nn/details',
					type: 'post',
					data: {
						userid: id,
						token: that.token
					},
					success: function(data, status) {
						that.popData = data.data
                        that.follow_val = data.data.gj_type

					},
					fail: function(err, status) {
						console.log(err)
					}
				})
				// 用户分类
				that.get_type()
			},
			blurs() {
				let that = this
				setTimeout(function() {
					that.showtype = false
				}, 500)
			},
			// 用户分类
			get_type() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/usertype',
					type: 'post',
					data: {
						userid: that.record_id,
						token: that.token
					},
					success: function(data, status) {
						console.log(data)
						if (data.data) {
							that.showtype2 = false
							that.t_name = data.data
						} else {
							that.showtype2 = true
							that.t_name = ''
						}
					},
				})
			},
			get_type2(i) {
				let that = this
				if(i==1){
					var mag='保存成功'
				}else{
					var mag="修改成功"
				}
				$.ajax({
					url: process.env.apiUrl +'saas/nn/usertype',
					type: 'post',
					data: {
						userid: that.record_id,
						token: that.token,
						usertype: that.t_name,
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.$message({
								message:mag,
								type: 'success'
							});
							that.get_type()
						} else {

						}
					},
				})
			},
			//跟进记录
			get_record() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/follow',
					type: 'post',
					data: {
						user_id: that.record_id,
						token: that.token
					},
					success: function(data, status) {
						that.recordData = data.data
						if (data.status == 1) {
							that.recordShow = true
							//that.recordLength = Number(data.map.count)
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//删除跟进记录
			del_record(id) {
				this.del_dialogVisible = true
				this.d_id = id
			},
			//确认删除记录
			confirm_del() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/del',
					type: 'post',
					data: {
						gj_id: that.d_id,
						token: that.token
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.pop(that.record_id);
							that.recordShow = false
							that.del_dialogVisible = false
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})

			},
			//发布
			issue() {
                if (!this.text_val) {
                    this.$message.error("请输入跟进内容");
                    return false;
                }
                if (!this.way_val) {
                    this.$message.error("请选择跟进方式");
                    return false;
                }
                if (!this.follow_val) {
                    this.$message.error("请选择跟进状态");
                    return false;
                }
				if (this.isSubmit) {
					return
				}
				this.isSubmit = true
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/addfollow',
					type: 'post',
					data: {
						bao_id: that.record_id,
						neirong: that.text_val,
						fangshi: that.way_val,
						lasttime: that.last_time,
						zhuangtai: that.follow_val,
						token: that.token
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.getData(that.now_page)
							that.$message.success(data.msg)
							//添加跟进记录
							that.get_record();
							//清空已添加的跟进内容
							that.text_val = ''; //文本域
							that.way_val = ''; //跟进方式
							that.last_time = ''; //下次跟进时间
							that.follow_val = ''; //跟进状态
						}else{
							that.$message.error(data.msg)
						}
					},
					fail: function(err, status) {
						console.log(err)
					},
					complete: function() {
						that.isSubmit = false
					}
				})
			},
			//多选
			handleSelectionChange(val) {
				let arr = []
				for (let i in val) {
					arr.push(val[i].user_id)
				}
				this.multipleSelection = arr
			},
			//转给他人
			move() {
				if (this.multipleSelection.length == 0) {
					this.$message.error({
						message: '请先选择客户'
					})
				} else {
					this.DialogVisible = true

					let that = this
					$.ajax({
						url: process.env.apiUrl +'saas/qk/yxlb',
						type: 'post',
						data: {
							token: this.token
						},
						success: function(data, status) {
							that.sellData = data.data
						},
						fail: function(err, status) {
							console.log(err)
						}
					})
				}
			},
			//确认分配
			confirm_move() {
				if (!this.sell_name) {
					this.$message.error({
						message: '请先选择销售'
					})
				} else {
					this.DialogVisible = false

					let that = this
					$.ajax({
						url: process.env.apiUrl +'saas/qk/zgtr',
						type: 'post',
						data: {
							user_id: that.multipleSelection,
							uid: that.sell_name,
							token: that.token
						},
						success: function(data, status) {
							if (data.status == 1) {
								that.$message({
									message: '分配成功',
									type: 'success'
								});
								setTimeout(() => {
									that.getData();
								}, 1000)
							}
						},
						fail: function(err, status) {
							console.log(err)
						}
					})
				}
			},
			//到访切换
			visit(i) {
				this.visit_state = !this.visit_state
				if (this.visit_state == true) {
					this.visit_txt = '未跟进'
				} else {
					this.visit_txt = '已跟进'
				}

				$.ajax({
					url: process.env.apiUrl +'saas/qk/dfqh',
					type: 'post',
					data: {
						id: i,
						token: this.token
					},
					success: function(data, status) {
						console.log(data)
					},
					fail: function(err, status) {
						console.log(err)
					}
				})

			},
			//          关闭右侧弹出框
			close() {
				this.popShow = false
			},
			//退回公海
			send_back() {
				this.send_state = true
			},
			confirm_back() {
				this.send_state = false

				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/qk/tuihui',
					type: 'post',
					data: {
						user_id: that.record_id,
						token: that.token
					},
					success: function(data, status) {
						//if(data.status == 1){
						//刷新视图
						that.getData();
						that.send_success();
						//}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			send_success() {
				this.$message({
					message: '删除成功',
					type: 'success'
				});
			},
			//删除所属顾问
			del() {
				this.select_name = $(".select2").find("option:selected").text();
				if (this.select_Val == '') {
					this.$message({
						duration: 2000,
						showClose: true,
						message: '请先选择顾问',
						type: 'error'
					});
				} else {
					this.centerDialogVisible = true

					let that = this
					$.ajax({
						url: process.env.apiUrl +'saas/qk/hgh',
						type: 'post',
						data: {
							userid: that.select_Val,
							token: that.token
						},
						success: function(data, status) {
							that.tableData = data.data
							if (data.status != 1) {
								that.totalNum = Number(data.map.count)
							}
						},
						fail: function(err, status) {
							console.log(err)
						}
					})

				}
			},
			handleCurrentChange(val) {
				this.now_page = val
				this.get_page()
			},
			get_page() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/hygj',
					type: 'post',
					data: {
						keshi: that.keshi,
						hetong: this.pact_num,
						name: this.vip_name,
						pname: this.cabeza_name,
						pphone: this.cabeza_tel,
						type: this.selectVal,
						salesperson: this.select_Val,
						page: this.now_page,
						pageone: that.pageSize,
						token: this.token
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.tableData = data.data
							//总条数
							that.totalNum = Number(data.map.count)
							that.show_zj = data.show_zj;
						} else {
							that.$message.error({
								message: data.msg
							})
						}

					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//清除搜索条件
			clear_search() {
				this.vip_name = '';
				this.cabeza_name = '';
				this.cabeza_tel = '';
				this.selectVal = '';
				this.select_Val = '';

				this.getData()
			}
		},
		watch: {
			checked() {
				if (this.checked) {
					let that = this
					$.ajax({
						url: process.env.apiUrl +'saas/qk/hygj',
						type: 'post',
						data: {
							hetong: this.pact_num,
							name: this.vip_name,
							pname: this.cabeza_name,
							pphone: this.cabeza_tel,
							type: this.selectVal,
							salesperson: this.select_Val,
							page: this.now_page,
							token: this.token,
							check: 1
						},
						success: function(data, status) {
							if (data.status == 1) {
								that.tableData = data.data
								//总条数
								that.totalNum = Number(data.map.count)
								that.show_zj = data.show_zj;
							}
						},
						fail: function(err, status) {
							console.log(err)
						}
					})
				} else {
					this.getData()
				}
			},
		}
	};
</script>

<style>
	.el-dialog__header {
		padding: 10px 20px 10px;
		color: #FFFFFF;
		background: #E6BE8A;
		text-align: center;
	}

	.el-dialog__title {
		color: #FFFFFF;
	}

	.el-input__inner {
		height: 36px;
		line-height: 36px;
	}

	.el-dialog__headerbtn {
		top: 13px;
	}
</style>
<style lang="less" scoped="scoped">
	.text_hidden{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	/*修改弹出框*/
	.el-dialog {
		.save-input {
			height: 26px;
			line-height: 26px;
			border-radius: 2px;
			border: 1px solid gainsboro;
			padding-left: 5px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 160px;
			margin-top: 10px;
		}

		.line {
			margin-top: 10px;

			.add {
				width: 20px;
				vertical-align: middle;
				text-align: center;
				font-weight: bolder;
				display: inline-block;
				background: #79C4C7;
				border-radius: 50%;
				color: white;
				font-size: 15px;
				cursor: pointer;
			}
		}
	}
	.fencss {
		padding:0 8px;
		color: #fff;
		background-color: #E6BE8A;
		border:0;
		border-radius: 2px;
	}
	/*确认删除*/
	.header .el-button--default {
		color: white;
	}

	.header .block .el-date-editor.el-input[data-v-82287e62],
	.header .block .el-date-editor.el-input__inner[data-v-82287e62] {
		width: 140px;
	}

	#app {
		padding: 10px;
		position: relative;
	}

	.right-pop {
		width: 800px;
		display: inline-block;
		position: absolute;
		background: white;
		border: 1px solid gainsboro;
		display: inline-block;
		position: absolute;
		top: 0;
		right: 0;
		z-index: 99;

		.head {
			padding: 10px;

			.head-img {
				width: 35px;
				float: left;
			}

			.name {
				margin-top: 9px;
				margin-left: 8px;
				display: inline-block;
			}

			.right {
				float: right;
				margin-top: 10px;

				.move {
					display: inline-block;
					float: left;
					width: 85px;
					text-align: center;
					padding: 5px 0;
					border: 1px solid #adadad;
					border-radius: 2px;
					margin-right: 2px;
					cursor: pointer;
				}

				.el-button--text {
					float: left;
					width: 85px;
					text-align: center;
					padding: 7px 0;
					border: 1px solid #adadad;
					border-radius: 2px;
					color: black;
				}

				.close {
					margin-top: 5px;
					margin-left: 7px;
					margin-right: 5px;
					width: 20px;
				}
			}

			.head_content {
				margin-bottom: 7px;
				clear: both;

				span {
					display: inline-block;
					margin-left: 30px;
					padding-top: 12px;
				}
			}
		}

		.el-tabs--border-card {
			box-shadow: none;
		}

		textarea {
			width: 100%;
			height: 63px;
		}

		.fade-enter-active,
		.fade-leave-active {
			transition: opacity 1s;
		}

		.fade-enter,
		.fade-leave-to {
			opacity: 0;
		}

		.el-tabs--border-card {
			border-left: 0;
			border-bottom: 0;
		}

		.down_form {
			margin-top: 15px;
			padding-bottom: 20px;
			max-height: 500px;
			overflow: hidden;
			overflow-y: scroll;

			.el-date-editor.el-input,
			.el-date-editor.el-input__inner {
				width: 135px;
				margin-left: 5px;
				float: left;
			}

			.issue {
				padding: 3px 11px;
				color: #fff;
				background-color: #E6BE8A;
				border: 1px solid #E6BE8A;
				border-radius: 2px;
			}

			.record-content {
				margin-bottom: 10px;

				.record {
					height: 40px;
					line-height: 40px;
					margin-bottom: 10px;
					margin-top: 20px;
					padding-left: 20px;
					background-color: rgb(241, 241, 241);
					color: rgb(102, 102, 102);

					span {
						display: inline-block;
						padding-right: 50px;
					}

				}

				.header-img {
					float: left;
					margin: 0 15px;
					width: 50px;
				}

				.img-txt {
					display: inline-block;
					padding: 2px 5px;
					border-radius: 10px;
					color: #fff;
					background-color: #E6BE8A;
					border-color: #2e6da4;
					font-size: 14px;
					font-weight: bold;
					margin-top: 18px;
				}

				.right-txt {
					float: right;
					padding-top: 18px;
					padding-right: 30px;
					color: rgb(93, 156, 236);
					display: inline-block;
				}

				.content {
					padding-left: 84px;
					min-height: 50px;
					clear: both;
				}

				.yet {
					width: 55px;
					line-height: 30px;
					background-color: #449d44;
					border: 0;
					border-radius: 5px;
					color: white;
					margin-left: 10px;
					font-size: 14px;
					cursor: pointer;
					outline: none;
				}

				.not {
					width: 55px;
					line-height: 30px;
					background-color: #f0ad4e;
					border: 0;
					border-radius: 5px;
					color: white;
					margin-left: 10px;
					font-size: 14px;
					cursor: pointer;
					outline: none;
				}
			}

		}

	}

	.header {
		margin-bottom: 15px;

		.name {
			display: inline-block;
			height: 36px;
			padding-left: 16px;
			margin-left: 5px;
			font-size: 14px;
			line-height: 1.42857143;
			color: #555;
			background-color: #fff;
			border: 1px solid #ccc;
			border-radius: 4px;
		}

		.el-button {
			padding: 6px 14px;
			background-color: #E6BE8A;
			margin-left: 15px;
			margin-right: 6px;
			vertical-align: middle;
		}

		.refresh-btn {
			width: 43px;
			border: 1px solid #E4E7ED;
			line-height: 24px;
			background-color: white;
			border-radius: 2px;
			cursor: pointer;
			vertical-align: middle;
		}

		.delete {
			width: 110px;
			color: #fff;
			border: 0;
			background-color: #E6BE8A;
			display: inline-block;
			padding: 8px 12px;
			margin-bottom: 0;
			font-size: 14px;
			font-weight: 400;
			line-height: 1.42857143;
			text-align: center;
			border-radius: 3px;
			cursor: pointer;
			margin-left: 5px;
		}
	}

	.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
		width: 250px;
	}
</style>
<style>
	.el-date-editor .el-range-separator{
		width: auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/genjin/vip.vue